<!-- 
    新增选择区域
    <area-picker type="add" @change="getAreaData"/>

    编辑选择区域
    <area-picker type="edit" :data.sync="data" @change="getAreaData"/>
-->
<template>
    <el-row>
        <el-col :span="8"> 
            <el-select :size="size == 'large' ? '' : size" v-model="address.regionProvince" style="width: 94%"
                value-key="region_id" placeholder="请选择" @change="selectArea(1)">
                <el-option :label="item.region_name" :value="item" v-for="item in provinceList" :key="item.region_id"></el-option>
            </el-select>
        </el-col>
        <el-col :span="8" v-if="cityList.length>0">
            <el-select :size="size == 'large' ? '' : size" v-model="address.regionCity" style="width: 94%"
                value-key="region_id" placeholder="请选择" @change="selectArea(2)">
                <el-option :label="item.region_name" :value="item" v-for="item in cityList" :key="item.region_id"></el-option>
            </el-select>
        </el-col>
        <el-col :span="8" v-if="districtList.length>0">
            <el-select :size="size == 'large' ? '' : size" v-model="address.regionDistrict" style="width: 100%"
                value-key="region_id" placeholder="请选择" @change="selectArea(3)">
                <el-option :label="item.region_name" :value="item" v-for="item in districtList" :key="item.region_id"></el-option>
            </el-select>
        </el-col>
    </el-row>
</template>

<script>
import api from '@/api/index.js'
import request from '@/utils/request'
export default {
    props: {
        type: { // add - 新增  edit - 编辑
            type: String,
            default: 'add'
        },
        data: {
            type: Object,
            default: function() {
                return {
                    regionProvince: {
                        region_name:  '',
                        region_id: ''
                    },
                    regionCity: {
                        region_name:  '',
                        region_id: ''
                    },
                    regionDistrict: {
                        region_name:  '',
                        region_id: ''
                    },
                }
            }
        },
        size: {
            type: String,
            default: 'small'
        }
    },
    data() {
        return {
            provinceList: [],
            cityList: [],
            districtList: [],
            address: {
                regionProvince: '',
                regionCity: '',
                regionDistrict: ''
            },
            manualHandle: false
        }
    },
    created() {
        if (this.type == 'add') {
            this.addAddressInit()
        }
    },
    watch: {
        data: {
            handler: function (val, oldVal) {
                // console.log('$$$$$',val, oldVal)
                if (this.type == 'edit' && !this.manualHandle) {
                    this.editAddressInit(val)
                }
            },
            deep: true,
            immediate: true
        }
    },
    methods: {
        addAddressInit() {
            if (this.provinceList.length == 0) {
                this.regionInfo(1, '0', 'add')
            }
        },
        editAddressInit(val) {
            this.address = {...this.data}
            this.regionInfo(1, '0', 'edit', true)
        },
        regionInfo(type, id, handleType, active) {  // type ： 1 省 2 市 3 区    handleType: add edit
            request({
                url: api.regionInfo,
                data: {
                    parentId: id
                }
            }).then(res => {
                // console.log(res)
                if (res.errorCode == 200) {
                    if (handleType == 'add') {
                        if (type == 1) {
                            this.provinceList = res.data || []
                            this.cityList = []
                        }
                        if (type == 2) {
                            this.cityList = res.data || []
                            this.districtList = []
                        }
                        if (type == 3) {
                            this.districtList = res.data || []
                        }
                    }
                    if (handleType == 'edit') {
                        if (type == 1) {
                            this.provinceList = res.data || []
                            this.cityList = []
                            if (active) {
                                if (this.address.regionProvince.region_id) {
                                    this.regionInfo(2, this.address.regionProvince.region_id, 'edit', true)
                                } else {
                                    let filter = this.provinceList.filter(item => item.region_name == this.address.regionProvince.region_name)
                                    // console.log(filter)
                                    if (filter.length > 0) {
                                        this.address.regionProvince = filter[0]
                                        this.regionInfo(2, this.address.regionProvince.region_id, 'edit', true)
                                    }
                                }
                            }
                        }
                        if (type == 2) {
                            this.cityList = res.data || []
                            this.districtList = []
                            if (active) {
                                if (this.address.regionCity.region_id) {
                                    this.regionInfo(3, this.address.regionCity.region_id, 'edit', true)
                                } else {
                                    let filter = this.cityList.filter(item => item.region_name == this.address.regionCity.region_name)
                                    // console.log(filter)
                                    if (filter.length > 0) {
                                        this.address.regionCity = filter[0]
                                        this.regionInfo(3, this.address.regionCity.region_id, 'edit', true)
                                    }
                                }
                            }
                            
                        }
                        if (type == 3) {
                            this.districtList = res.data || []
                            if (active) {
                                if (!this.address.regionDistrict.region_id) {
                                    let filter = this.districtList.filter(item => item.region_name == this.address.regionDistrict.region_name)
                                    // console.log(filter)
                                    if (filter.length > 0) {
                                        this.address.regionDistrict = filter[0]
                                    }
                                }
                            }
                        }
                    }
                }
            }).catch(err => {
                console.log(err)
            })
        },

        selectArea(type) {
            if (!this.manualHandle) this.manualHandle = true
            if (type == 1) { // 选择省
                this.regionInfo(2, this.address.regionProvince.region_id, 'add')
                this.address.regionCity = ''
                this.address.regionDistrict = ''
            }
            if (type == 2) { // 选择市
                this.regionInfo(3, this.address.regionCity.region_id, 'add')
                this.address.regionDistrict = ''
            }
            this.$emit('update:data', this.address)
            this.$emit('change', this.address)
        },
    }
}
</script>

<style>

</style>